// components/MessageModal.jsx
import React, { useEffect, useState } from "react";
import "../styles/MessageModal.css";

export default function MessageModal({ isOpen, onClose, onMessageCreated }) {
  const [groups, setGroups] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    content: "",
    message_type: "info",
    is_global: false,
    selectedGroups: [],
  });

  useEffect(() => {
    if (!isOpen) {
      setFormData({
        title: "",
        content: "",
        message_type: "info",
        is_global: false,
        selectedGroups: [],
      });
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    let mounted = true;
    fetch(`${process.env.REACT_APP_API_URL}/getData/groups`)
      .then((r) => r.json())
      .then((data) => mounted && setGroups(data))
      .catch((e) => console.error(e));
    return () => {
      mounted = false;
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox" && name === "is_global") {
      setFormData((p) => ({ ...p, is_global: checked, selectedGroups: [] }));
    } else {
      setFormData((p) => ({ ...p, [name]: value }));
    }
  };

  const handleGroupSelect = (e) => {
    const { value, checked } = e.target;
    setFormData((prev) => {
      const next = checked
        ? [...prev.selectedGroups, value]
        : prev.selectedGroups.filter((g) => g !== value);
      return { ...prev, selectedGroups: next };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const headers = { "Content-Type": "application/json" };
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      const res = await fetch(`${process.env.REACT_APP_API_URL}/messages`, {
        method: "POST",
        headers: headers,
        credentials: 'include',
        body: JSON.stringify(formData),
      });
      if (res.ok) {
        onMessageCreated();
        onClose();
      } else {
        console.error("Server error saving message");
      }
    } catch (err) {
      console.error(err);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="message-modal-overlay"
      role="dialog"
      aria-modal="true"
      onClick={(e) => {
        if (e.currentTarget === e.target) onClose();
      }}
    >
      <div className="message-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Nowa Wiadomość</h2>
        <form onSubmit={handleSubmit}>
          <label>Tytuł</label>
          <input
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />

          <label>Treść</label>
          <textarea
            name="content"
            value={formData.content}
            onChange={handleChange}
            required
          />

          <label>Typ</label>
          <select
            name="message_type"
            value={formData.message_type}
            onChange={handleChange}
          >
            <option value="info">Informacja</option>
            <option value="warning">Ważne</option>
            <option value="alert">Alert</option>
          </select>

          <label>
            <input
              type="checkbox"
              name="is_global"
              checked={formData.is_global}
              onChange={handleChange}
            />
            Wiadomość globalna
          </label>

          {!formData.is_global && (
            <div className="message-groups-section">
              {groups.map((g) => (
                <label key={g.group_code}>
                  <input
                    type="checkbox"
                    value={g.group_code}
                    checked={formData.selectedGroups.includes(g.group_code)}
                    onChange={handleGroupSelect}
                  />
                  {g.group_name} ({g.group_code.trim()})
                </label>
              ))}
            </div>
          )}

          <div className="message-modal-actions">
            <button type="submit" className="btn btn-primary">
              Zapisz
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Anuluj
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
